{
  "optionsBoardHeader": {
    "types": {
      "call": "Call",
      "put": "Put"
    },
    "datesExpirations": {
      "errorFetch": "Не удалось получить даты экспирации"
    }
  }
}
